import { array, number, object } from "yup";
import { dateMax } from "./utils";

export const regenerateBalanceSchema = object({
  paliers: array().of(
    object({
      date_palier: dateMax().required(" "),
      loyer_hc: number().required(" "),
      charges: number().required(" "),
    }),
  ),
});
